export default () => (dispatch, getState) => {

  const { token, clientEmail }  = getState()

  const makeTheCall = (url, callback) => {
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token &&
          `Token ${token}`,
      }
    })
    .then(d => d.json())
    .then(callback)
    .catch(error => {
      console.error(error);
    })
  }

  makeTheCall(`${process.env.REACT_APP_API_URL}/map/wtapprovedfunds/allow_client_logo/?clientEmail=${clientEmail}`, data => {
    dispatch({ type: 'SET_CLIENT_PDF', key: 'allowClientLogo', value: data.allowClientLogo })
  })

};


// WEBPACK FOOTER //
// ./src/actions/query-api/allow-client-logo.js